module.exports = __webpack_public_path__ + "img/MoonSword 4.e4e710de.png";